import { weekDayToNumber } from "../constants/weekDayToNumber";
import { parseScheduleSlot } from "./scheduleSlotUtils";

function normalizeTimeValue(time) {
    if (!time) return "00:00:00";
    return time.length === 5 ? `${time}:00` : time;
}

export function buildPeriodSchedulePayload({
    startDate,
    endDate,
    selectedWeekdays,
    selectedTimes,
    timeZone,
    periodId = null,
}) {
    const scheduleItems = Object.entries(selectedTimes)
        .filter(([weekday]) => selectedWeekdays.includes(weekday))
        .map(([key, value]) => {
            const { start: timeFrom, end: timeTo, quantity: parsedQuantity } = parseScheduleSlot(value);

            let adjustedTimeTo = timeTo;
            const [endHours, endMinutes] = timeTo.split(":").map(Number);
            if (endHours >= 24) {
                const normalizedHours = endHours - 24;
                adjustedTimeTo = `${normalizedHours.toString().padStart(2, "0")}:${endMinutes.toString().padStart(2, "0")}`;
            }

            return {
                weekday: weekDayToNumber[key],
                start_time: normalizeTimeValue(timeFrom),
                end_time: normalizeTimeValue(adjustedTimeTo),
                quantity: parsedQuantity,
            };
        });

    return {
        start_date: startDate,
        end_date: endDate || null,
        time_zone: timeZone,
        schedule_items: scheduleItems,
        ...(periodId ? { period_id: periodId } : {}),
    };
}
